import { Swiper } from 'swiper';
import { A11y, Navigation, Thumbs } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-testimonial-image-logo__slider-wrapper .swiper-main'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		const slides = slider.querySelectorAll('.swiper-slide');
		const thumbnailSlider =
			slider.parentElement.querySelector('.image-swiper');

		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);

		const settingsThumbnails = {
			slidesPerView: 1,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				576: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		};

		new Swiper(thumbnailSlider, settingsThumbnails);

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation, Thumbs],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-testimonials__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-testimonials__swiper--${index} .swiper-button-next`,
			},
			thumbs: {
				swiper: thumbnailSlider,
			},
		};

		new Swiper(slider, settings);
	});
}
